import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStoreAddPredicate = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const addPredicate = useStore(store, (s) => s.addPredicate);

    return addPredicate;
};
